import { Component, OnInit , Input , Output} from '@angular/core';
import { EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-delete',
  standalone: true,
  imports: [],
  templateUrl: './confirm-delete.component.html',
  styleUrl: './confirm-delete.component.scss'
})
export class ConfirmDeleteComponent implements OnInit {
	@Input() public message : string = '';
	@Output() passEntry: EventEmitter<any> = new EventEmitter();

	constructor(
  		public activeModal: NgbActiveModal
  	) { 
      
    }

	ngOnInit(): void {
		
	}
  
	confirm () {
		this.activeModal.close(true);
	}
  
	cancel () {
		this.activeModal.close(false);
	}
  
	close () {
		this.activeModal.close(false);
	}
}
